// src/pages/Home.js
import React from 'react';
import founderImage from '../assets/images/founder.jpg';     // Simon Kihumba
import coFounderImage from '../assets/images/co-founder.JPG';// Nelly Kihumba
import PageContainer from '../components/PageContainer';
import './Home.css';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

function Home() {
  const location = useLocation();
  const [showScrollTop, setShowScrollTop] = useState(false);

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  // Show/hide scroll-to-top arrow
  useEffect(() => {
    const onScroll = () => {
      setShowScrollTop(window.scrollY > 200);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <PageContainer>
        <div className="page-header">
          <h1>Welcome to NESIM Intranet</h1>
        </div>
       
        {/* Three Columns: Founders (Left), Text (Center), Values Circle (Right) */}
        <div className="page-section">
          <h2>Who are we?</h2>
          <div className="three-column-flex">
            {/* Left: Founders */}
            <div className="column-left">
              <div className="founder-card">
                <img src={founderImage} alt="Simon Kihumba" className="founder-photo" />
                <p className="founder-caption">Simon Kihumba, Founder</p>
              </div>
              <div className="founder-card">
                <img src={coFounderImage} alt="Nelly Kihumba" className="founder-photo" />
                <p className="founder-caption">Nelly Kihumba, Co-Founder</p>
              </div>
            </div>

            {/* Center: Text */}
            <div className="column-center">
              <p>
                Nesim Investments Limited was founded in 1988 by Simon and Nelly Kihumba.
                Initially established as a milling company for local brewers in Nairobi, we have 
                grown significantly over the years, now serving the entire Eastern African region 
                and actively expanding our footprint across Africa and beyond.
              </p>
              <p>
                Key milestones include introducing starch in brewing in 1983, forging strategic 
                distributorship agreements with multinational corporations, and securing major 
                contracts with leading breweries. Today, Nesim stands as a trusted partner for 
                breweries seeking quality, innovation, and reliability.
              </p>
            </div>

          </div>
        </div>

        {/* ========== BREW PRODUCTS SECTION ========== */}
        <div className="page-section">
          <h2>Think Brewing Solutions, Think NESIM</h2>
          <p className="hero-subtitle">
            We deliver the right quality brewing solutions at the right quantity 
            with professionalism and integrity at the right time.
          </p>

          <h3>We specialize in:</h3>

          <div className="three-column-products">
            {/* Brewing Aids Column */}
            <div className="product-col">
              <img src={require('../assets/images/prod1.jpg')} alt="Brewing Aids" className="product-img" />
              <h4>Brewing Aids</h4>
              <p>
                Brewing aids generally refer to various substances or products that are used in the process of brewing beverages,
                particularly in the context of brewing beer. These aids are employed to enhance or facilitate the brewing process.
                Brewing Aids assist in beer clarification, beer filtration, flavor stability, and foam control.
              </p>
            </div>

            {/* Brewing Salts Column */}
            <div className="product-col">
              <img src={require('../assets/images/prod2.jpg')} alt="Brewing Salts" className="product-img" />
              <h4>Brewing Salts for Beers and Spirits</h4>
              <p>
                Before you can build a specific water profile, you need to know what is in the water you are brewing with.
                Adjusting your water profile is simple, and it can make the difference between brewing a good beer and brewing 
                a great beer. Brewing salts assist in pH control, correct mineral deficiencies, control acidity, and enhance flavors.
              </p>
            </div>

            {/* Brewing Enzymes Column */}
            <div className="product-col">
              <img src={require('../assets/images/prod3.jpg')} alt="Brewing Enzymes" className="product-img" />
              <h4>Brewing Enzymes</h4>
              <p>
                An enzyme is a protein that catalyzes a chemical reaction, greatly speeding it up while not being consumed 
                by the reaction. Enzymes play an important role in the production of most fermented beverages. Different types
                of enzymes are intrinsic to the grains used in brewing, but there are two major classes: proteases and diastases.
              </p>
            </div>
          </div>
        </div>

        {/* ========== STRATEGIC PILLARS SECTION ========== */}
        <div className="page-section strategic-pillars-section">
          <h2 className="pillars-title">Our Strategic Pillars</h2>
          <div className="pillars-grid">
            <div className="pillar-card">
              <h4>Profitability & Sustainability</h4>
              <p>Achieve KES 1.7B in revenue within 5 years through responsible business practices.</p>
            </div>
            <div className="pillar-card">
              <h4>Global Standards & Systems</h4>
              <p>Automate and implement efficient SOPs, workflows, and supply chain systems.</p>
            </div>
            <div className="pillar-card">
              <h4>Loyal & Profitable Customers</h4>
              <p>Onboard and retain customers by offering unrivaled brewing solutions and service.</p>
            </div>
            <div className="pillar-card">
              <h4>Attract & Retain Talented People</h4>
              <p>Nurture a motivated workforce through standardized recruitment and career growth.</p>
            </div>
          </div>
        </div>

        {/* ========== VALUES CIRCLE SECTION ========== */}
        <div className="page-section values-circle-section">
          <div className="values-circle-container">
            <div className="values-circle-center">Our Values</div>
            <div className="values-circle-item value-confidentiality">Confidentiality</div>
            <div className="values-circle-item value-reliability">Reliability</div>
            <div className="values-circle-item value-godly">Godly<br/>Values</div>
            <div className="values-circle-item value-timeliness">Timeliness</div>
            <div className="values-circle-item value-professionalism">Professionalism</div>
            <div className="values-circle-item value-quality">Quality</div>
            <div className="values-circle-item value-integrity">Integrity</div>
          </div>
        </div>
      </PageContainer>
      {/* Scroll to Top Arrow */}
      {showScrollTop && (
        <button className="scroll-to-top-btn" onClick={handleScrollTop} aria-label="Scroll to top">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="16" cy="16" r="16" fill="#0a3970"/>
            <path d="M10 18l6-6 6 6" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      )}
    </>
  );
}

export default Home;
